// src/public/rsvp/rsvpApi.js
import { http } from 'shared/api/http';

function unwrap(res) {
  return res?.data ?? res;
}

export const rsvpApi = {
  // GET /api/v1/rsvp/{token}
  async get(token) {
    const res = await http(`/api/v1/rsvp/${token}`, {
      method: 'GET',
      auth: false, // ✅ public endpoint
    });

    return unwrap(res);
  },

  // POST /api/v1/rsvp/{token}/answer
  async answer(token, answer) {
    const res = await http(`/api/v1/rsvp/${token}/answer`, {
      method: 'POST',
      body: { answer }, // "YES" | "NO"
      auth: false, // ✅ public endpoint
    });

    return unwrap(res);
  },
};
